import getExtensionSettings from './extension-settings';
import getExtension from './extension';
import getExtensions from './extensions';

export default {
  getExtensionSettings,
  getExtension,
  getExtensions,
};
